// SHIPING COUNTDOWN
// GET THE COUNTDOWN ELEMENT && DECLARE INTERVAL VARIABLE
const currentCountdownEle = document.querySelector(".current-countdown");
const currentCountdownTitle = document.querySelector(".dispatch-title");
let intervalCountdown = null;

if (currentCountdownEle) {
  const shippingCountdown = function(shippingTime, currentCountdownEle) {
    const prevOutput = currentCountdownEle.querySelector("span");
    if (prevOutput) {
      prevOutput.parentNode.removeChild(prevOutput);
    }

    // CALCULATE NEW SHIPPING TIME
    const currentTime = new Date().getTime();

    const timeLeftToShipping = shippingTime - currentTime;

    const nd = new Date(timeLeftToShipping);

    const hours = nd.getHours();
    const day = new Date().getDay();

    // REMOVE COUNTDOWN IF THE TIME TO SHIPPING IS MORE THAN 12H
    if (day === 6 || day === 0 || hours >= 12) {
      clearInterval(intervalCountdown);
      return false;
    }

    // UPDATE COUNTDOWN
    const newCountdownValue = document.createTextNode(
      // "Order before 1 PM (AEST): " +
        hours +
        ":" +
        nd.getMinutes() +
        ":" +
        nd.getSeconds() +
        " " +
        "LEFT"
    );

    const timeLeft = document.createElement("span");
    timeLeft.appendChild(newCountdownValue);

    currentCountdownEle.appendChild(timeLeft);
    currentCountdownEle.setAttribute('style', "display: block");
    currentCountdownTitle.setAttribute('style', "display: flex");
    return false;
  };

  // DEFINE TIME
  const newDateObj = new Date();

  // DEFINE TIME: SET BRISBANE (AUSTRALIA) SHIPPING TIME
  const shippingHour = newDateObj;
  shippingHour.setHours(3, 0, 0, 0);

  // DEFINE TIME: CALCULATE TIME LEFT TO SHIPPING
  const shippingTime = shippingHour.getTime();
  const currentTime = newDateObj.getTime();

  const timeLeftToShipping = shippingTime - currentTime;

  const nd = new Date(timeLeftToShipping);

  const hoursLeftToShipping = nd.getHours();

  // SET OUTPUT: COUNTDOWN || MESSAGE
  if (hoursLeftToShipping < 15) {
    intervalCountdown = setInterval(function() {
      shippingCountdown(shippingTime, currentCountdownEle);
    }, 1000);
  } else {
    currentCountdownEle.appendChild(staticMsg());
  }
}
// END: SHIPING COUNTDOWN

